import {Injectable} from "@angular/core";
import { HttpClient , HttpHeaders } from '@angular/common/http';
import { Observable , throwError  } from 'rxjs';
import { Session } from "../model/session";
import { Usuario } from "../model/usuario";
import { retry , catchError } from 'rxjs/operators';
import { environment } from "src/environments/environment";

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'Basic ' + btoa('croamora:cristianroa.123')
  })
};  
const httpOptionsFile = {

  headers: new HttpHeaders({    
    'Authorization': 'Basic ' + btoa('croamora:cristianroa.123')
  })
};

@Injectable({
  providedIn: 'root'
})

export class AuthenticationService {

 constructor(private http:HttpClient) {}

 private basePath = 'usuario/login';
//  private basePathParametro = 'parametros/parametro/';
 
  login(usuario : Usuario): Observable<any> {
      return this.http.post<Usuario>(environment.apiEndpoint + this.basePath, usuario, httpOptions).pipe(
        catchError(this.handleError)
      );
  }

 /* obtenerParametro(idParametro:number){      
      return this.http.get(environment.apiEndpoint  +this.basePathParametro+idParametro, httpOptions).pipe(
        catchError(this.handleError)
      );
    }*/

  logout(): Observable<Boolean> {
     // return this.http.post(this.basePath + 'logout', {}).map(this.extractData);
     
     return null;
  }

  private extractData(res: Response) {
      let body = res.json();
      return body;
  }

  handleError(error) {    
      let errorMessage = '';
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.error.message}`;
      return throwError(errorMessage);
  }
}